import { render, staticRenderFns } from "./VisitDateDetail.vue?vue&type=template&id=5641a470&scoped=true"
import script from "./VisitDateDetail.vue?vue&type=script&lang=js"
export * from "./VisitDateDetail.vue?vue&type=script&lang=js"
import style0 from "./VisitDateDetail.vue?vue&type=style&index=0&id=5641a470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641a470",
  null
  
)

export default component.exports